<template>
  <div class="ips-login__content self">
    <div class="relative">
      <p class="system_name mgt-0">智慧物业信息管理系统</p>
      <div class="login_container">
        <div class="top_bdr"></div>
        <slot></slot>
        <div class="footer_bdr"></div>
      </div>
     <div class="mgt-10 txt-warning fs-12 login_warning">温馨提示：涉密不上网，上网不涉密!</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoginBackground"
  , data() {
    return {}
  }
  , computed: {}
  , methods: {}
  , mounted() {
    console.log(this.$route)
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/login";
@import "../../../assets/scss/login_bdr";

.login_warning{
  position: absolute;
  left: 0;
  bottom: -35px;
  width: 466px;
}
</style>
